import e from "react";
import { c as s, t as c } from "./app-a75c1d35.mjs";
import { B as u } from "./Block-9b78bd10.mjs";
import { V as i } from "./VideoIcon-87fb4a33.mjs";
import "./index-615eb227.mjs";
const d = "quotes", p = "quotes__content", x = "quote", _ = "desktop", f = "quote__image", T = "quote__text-container", E = "quote__text", C = "quote__reference-text", t = {
  quotes: d,
  quotesContent: p,
  quote: x,
  desktop: _,
  quoteImage: f,
  quoteTextContainer: T,
  quoteText: E,
  quoteReferenceText: C
};
function B({ quotes: a }) {
  return /* @__PURE__ */ e.createElement(u, { className: t.quotes, "data-testid": "quotes" }, /* @__PURE__ */ e.createElement(u.Content, { className: t.quotesContent }, a.map((o, n) => /* @__PURE__ */ e.createElement(g, { key: o.id || n, ...o }))));
}
function g({
  text: a,
  referenceText: o,
  iconVideoSrc: n,
  iconFallbackImgSrc: r,
  iconAltText: m,
  className: q,
  ...l
}) {
  return /* @__PURE__ */ e.createElement(
    "blockquote",
    {
      className: s(q, t.quote),
      ...l,
      "data-testid": "quote"
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        role: "presentation",
        className: t.quoteImage,
        title: m,
        "data-testid": "quote-image"
      },
      /* @__PURE__ */ e.createElement(i, { src: n, fallbackImgSrc: r })
    ),
    /* @__PURE__ */ e.createElement("div", { className: t.quoteTextContainer, "data-testid": "quote-content" }, /* @__PURE__ */ e.createElement(
      "p",
      {
        className: s(t.quoteText, c.textsComponentTitleBold)
      },
      a
    ), o && /* @__PURE__ */ e.createElement(
      "p",
      {
        className: s(
          t.quoteReferenceText,
          c.textsLeadText
        )
      },
      o
    ))
  );
}
export {
  B as Quotes
};
//# sourceMappingURL=Quotes.js.map
